import { render } from "./Layout.vue?vue&type=template&id=53ac7146"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Views/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53ac7146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53ac7146', __exports__)) {
    api.reload('53ac7146', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=53ac7146", () => {
    api.rerender('53ac7146', render)
  })

}


export default __exports__